// extracted by mini-css-extract-plugin
export default {"hero":"Card_hero__BTyIm","ant-card-head":"Card_ant-card-head__ibscF","simple":"Card_simple__hZroP","wrapper":"Card_wrapper__AVMB+","actions":"Card_actions__b8jSy"};